module.exports = __webpack_public_path__ + "static/background-tab-ae1c466f30bfb725c32d7f548e502cad.svg";